import { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-normas-jur.jpeg";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { Response, Search, useNormas } from "../../hooks/useNormas";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Submit } from "./helpers/submit";
import { Description } from "../../components/Description";
import { Modal } from "../../components/Modal";
import mock from "../../mocks/info";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function Normas() {
  usePageTrack();

  const pathname = useLocation().pathname;
  const [results, setResult] = useState<Response|null>(null);
  const [page, setPage] = useState<number>(1);
  const [order, setOrder] = useState<string>('');
  const initialSearch = pathname?.split('/')[2];
  const firstSearch = {type: initialSearch}
  const firstData: Response = useNormas(initialSearch);
  
  const [search, setSearch] = useState<Search|null>(initialSearch? firstSearch : null);

  const options: any = []; // usePageAttributes(pathname?.split('/')[1], mapAttributes);

  const [clickedInfo, setClickedInfo] = useState(mock);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  async function submit(_search: Search|null, _page: number = 0, _order: string = '') {
    if(!_search) _search = search;
    if(!_page) _page = page;
    if(!_order) _order = order;
    const result = await Submit(_search, _page, _order);
    setResult(result);
    setSearch(_search);
    setPage(_page);
    setOrder(_order);
  }

  // function mapAttributes(attr:any) {
  //   if(!attr?.attributes?.contentSections?.length) return;
  //   return {
  //     form: attr.attributes.contentSections.find((i: any) => i.__component === "forms.normas-form"),
  //     list: attr.attributes.contentSections.find((i: any) => i.__component === "sections.list-content")
  //   }
  // }
  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Description>
        Aqui você encontra os principais Tratados Internacionais do tema, Constituições, Leis Federais, Medidas Provisórias e Decretos. Estamos sempre atualizando a nossa base de dados e, em breve, disponibilizaremos os projetos de lei que tratem de matérias atinentes aos direitos autorais.
      </Description>
      <Content>
        <Form 
          formAttr={options?.form} 
          initialSearch={initialSearch}
          submit={submit}
        />
        <Results 
          results={results?.results || firstData.results} 
          pagination={results?.pagination || firstData?.pagination} 
          submit={submit}
          onClick={(clicked) => {
            setClickedInfo(clicked);
            setIsModalOpen(true);
          }}
        />
        <Modal isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {clickedInfo.map(info => (
          <div key={info.title} ref={info.content}>
              <span>{info.title}</span>
              <section>{info.content}</section>
            </div>
          ))}
        </Modal>
      </Content>
      <Footer />
    </>
  );
}

export default Normas;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;